import { getAvatarUrl } from "src/Common/common";
import { getMinutesFromFormattedHours } from "src/Common/function";
import { timesheetGridClass, StoredTimeCell, TotalTimeCell } from "./TimesheetTable";

const TotalTechItem = ({ tech }) => {
  if (!tech) return null;

  const totalMinutes =
    getMinutesFromFormattedHours(tech.regularTime) +
    getMinutesFromFormattedHours(tech.travelTime) +
    getMinutesFromFormattedHours(tech.overTime);

  return (
    <div className={`${timesheetGridClass(false)} h-[72px] border-b border-[#E5E8F3] last:border-b-0`}>
      <div className="flex items-center gap-3 min-w-0">
        <img src={getAvatarUrl(tech.user.avatar)} className="w-6 h-6 rounded-full object-cover shrink-0" />
        <p className="font-OpenSansRegular text-[14px] leading-[20px] text-[#5F6477] truncate">
          {tech.user.name}
        </p>
      </div>
      <StoredTimeCell value={tech.regularTime} />
      <StoredTimeCell value={tech.travelTime} />
      <StoredTimeCell value={tech.overTime} />
      <TotalTimeCell minutes={totalMinutes} />
    </div>
  );
};

export default TotalTechItem;
